import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../../store';
import {ActivatedRoute, Router} from '@angular/router';
import {FormControl} from '@angular/forms';
import {IFcDropdownSelectOption} from "../../../../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";
import {Location} from '@angular/common';
import {Observable} from "rxjs";
import {Subject} from "rxjs";
import options from './logs-options';
import {map, takeUntil} from "rxjs/operators";
import {FilterPipe} from "../../../../shared/pipes/filter.pipe";

@Component({
    selector: 'db-hosting-logs',
    templateUrl: './hosting-logs.component.html',
    styleUrls: ['./hosting-logs.component.scss'],
    standalone: false
})
export class HostingLogsComponent implements OnInit, OnDestroy {

  public logs: string[] = [];
  public websiteId: number;
  public status: FormControl = new FormControl(1000);
  public log: FormControl = new FormControl("access");
  public searchTerm: FormControl = new FormControl("");
  public statusOptions: IFcDropdownSelectOption[] = options['statusOptions'];
  public logsOptions: IFcDropdownSelectOption[] = options['logsOptions'];
  public logsLoading$: Observable<boolean>;
  public currentPage: number = 1;
  public itemsPerPage: number = 20;
  public itemsCount: number;
  public prevLogValue: string;
  public prevStatusValue: string;
  public hasHostingBanner: any;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _filterPipe: FilterPipe,
    private _route: ActivatedRoute,
    private _router: Router,
    private location: Location
  ) {
  }

  ngOnInit(): void {
    this._initData();
    this.getLogs(true);
    this.addEventHandlers();
  }

  private setPaginationData(): void {
    const filteredLogsForPagination = this._filterPipe.transform(this.logs, this.searchTerm.value);
    this.itemsCount = (this.status.value > filteredLogsForPagination.length ? filteredLogsForPagination.length : this.status.value);
    this.currentPage = 1;
  }


  public onChangePage(page: number): void {
    this.currentPage = page;
  }

  private addEventHandlers(): void {

    this.logsLoading$ = this._store.select(fromStore.getLogsLoading(this.websiteId))
      .pipe(takeUntil(this._destroyStream$));

    this._store.select(fromStore.getLogs(this.websiteId, 5, "access"))
      .pipe(
        takeUntil(this._destroyStream$),
        map((logs: any) => logs[0] ? logs[0].trim().split('\n') : [])
      )
      .subscribe(logs => {
      this.logs = logs;
      this.setPaginationData();
    });

    this.searchTerm.valueChanges
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(() => {
      this.setPaginationData();
    });

  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  private _initData(): void {
    const userId = this._route.snapshot.parent.parent.data['user'].id;
    this.hasHostingBanner = localStorage.getItem("showConnectBanner" + userId);
    this.websiteId = this._route.snapshot.parent.parent.data['website'].id;

    const queryParams: any = (<any>this._route.queryParams).value;
    queryParams.log && this.log.setValue(queryParams.log);

    this.prevLogValue = this.log.value;
    this.prevStatusValue = this.status.value;
  }

  public getLogs(refresh = false, keepQuery = false): void {
    if (this.status.value === this.prevStatusValue && this.log.value === this.prevLogValue && !refresh) { return; }
    this._store.dispatch(new fromStore.LoadLogs(this.websiteId, this.status.value, this.log.value));
    this.prevLogValue = this.log.value;
    this.prevStatusValue = this.status.value;
    keepQuery && this._setQueryParam();
  }

  private _setQueryParam(): void {
    const queryParams = {
      'log': this.log.value,
    };

    const urlTree = this._router.createUrlTree([], {
      relativeTo: this._route,
      queryParams: queryParams,
      // skipLocationChange: true
    });
    this.location.replaceState(urlTree.toString());
  }

}
